export default {
  reserveBtnText: "Download\nGame",
  pageTitle: "RO World Journey Player Co-Creation",
  loginBtn: "Login",
  logoutBtn: "[ Logout ]",
  joinActivityText: '<span class="number">${n}</span><br>players have joined the co-creation event',
  search: "Search",
  searchPlaceholder: "Enter creator name / keyword",
  filter: "Filter",
  sortBy: "Sort By",
  sortByTime: "Latest",
  sortByHot: "Hot",
  releaseTime: "Release Time",
  noLimit: "All",
  oneDay: "Within 1 Day",
  oneWeek: "Within 1 Week",
  reset: "Reset",
  loginTip: "Login to join the co-creation",
  nowLoginBtn: "Login Now",
  home: "Back to Home",
  creativeCenter: "My Works",
  developmentLog: "Dev Log",
  devSectionSubtitle: "For everyone awaiting RO's return",
  feedback: "Feedback",
  feedbackPopupTitle: "Submit Feedback",
  feedbackAccount: "Account:",
  notLoggedIn: "Not logged in",
  feedbackEmail: "Email:",
  feedbackEmailPlaceholder: "Enter your contact email",
  feedbackCategory: "Category:",
  feedbackCategoryPlaceholder: "Select feedback category",
  feedbackCat1: "Game Bug",
  feedbackCat2: "Feature Request",
  feedbackCat3: "System Optimization",
  feedbackCat4: "Other",
  feedbackContent: "Feedback Content:",
  feedbackContentPlaceholder: "Please describe your feedback in detail",
  feedbackAttachment: "Attachments",
  feedbackAttachmentLimit: "Up to 3 attachments",
  feedbackAddAttachment: "Add Attachment",
  feedbackErrEmail: "Please enter your email",
  feedbackErrCategory: "Please select a category",
  feedbackErrContent: "Please enter your feedback",
  feedbackErrFileSize: "File size cannot exceed 10MB",
  feedbackErrFileType: "Only images (JPG/PNG) and documents (PDF/DOC/DOCX) are supported",
  exitConfirmTitle: "Notice",
  exitConfirmLine1: "Unsaved content will be lost upon exit",
  exitConfirmLine2: "Exit?",
  publishTime: "Published: ",
  selectType: "Select Type",
  createType1: "Costume Design",
  createType2: "Headgear Design",
  createType3: "Meme Event",
  createType4: "My RO Memories",
  createType5: "Photo Showcase",
  createType6: "My Poring",
  createType7: "Class Sharing",
  ugcJoinBtn: 'Join',
  kolPopupTitle: "KOL Application",
  kolAccount: "Current Account:",
  kolEmail: "Email:",
  kolEmailPlaceholder: "Enter your contact email",
  kolDiscordId: "Discord User ID:",
  kolDiscordIdPlaceholder: "Enter your Discord User ID",
  kolSpecialty: "Creative Specialty:",
  kolSpecialtyPlaceholder: "Select your creative specialty",
  kolSpecialty1: "Strategy Guide",
  kolSpecialty2: "Art Design",
  kolSpecialty3: "Video Production",
  kolSpecialty4: "Others",
  kolWorkUrl: "Link to Past Works:",
  kolWorkUrlPlaceholder: "Enter links to past works, separate multiple links with commas",
  kolFollower: "Subscribers:",
  kolFollowerPlaceholder: "Enter current subscriber count",
  kolSubmitBtn: "Submit",
  kolErrEmail: "Please enter your email",
  kolErrEmailFormat: "Please enter a valid email format",
  kolErrDiscord: "Please enter your Discord User ID",
  kolErrSpecialty: "Please select a creative specialty",
  kolErrWorkUrl: "Please enter links to past works",
  kolErrFollower: "Please enter a valid subscriber count",
  kolSubmitSuccess: "Application submitted successfully",
  feedbackSuccessTitle: 'Dear Novice',
  feedbackSuccessContent: 'Congratulations! Your submission was successful!',
  kolSubmitFail: "Submission failed, please try again later",
  kolNetworkFail: "Submission failed, please check your network connection",
  kolSubtitle: "Join Creator Team",
  kolContent: "Connect and learn with talented creators while earning exclusive rewards! Tap to apply now!",
  kolViewBtn: "View",
  lotterySubTitle: 'Participate in co-creation events to earn points,<br><span class="red">then draw for limited in-game rewards and exquisite physical merchandise!</span>',
  drawSubTitle: 'Top Rewards Highlights',
  physicalRewardsLabel: 'Physical Rewards:',
  inGameRewardsLabel: 'In-game Rewards:',
  myPoints: "My Points: ",
  viewPointDetail: "View Point Details >>",
  currentTitle: "Current Title: ",
  taskRuleBtn: "Event Rules",
  taskBtnFinished: "Completed",
  taskBtnEnded: "Ended",
  taskBtnGo: "Go Now",
  taskDailyLoginTitle: "First Daily Login",
  taskDailyLoginDesc: "Log in daily to the page (5 pts)",
  taskReserveTitle: "Download Game",
  taskReserveDesc: "Complete game download for the first time (25 pts)",
  taskFeedbackTitle: "Submit Feedback",
  taskFeedbackDesc: "Submit feedback for the first time for the day (15 pts)",
  taskRoMemoryTitle: "My Poring Submission",
  taskRoMemoryDesc: "Make a first submission for the day (25 pts), weekly cap of 50 pts",
  taskCostumeTitle: "Job Sharing Submission",
  taskCostumeDesc: "Make a first submission for the day (25 pts), weekly cap of 25 pts",
  taskPhotoTitle: "Photo Sharing Submission",
  taskPhotoDesc: "Make a first submission for the day (25 pts), weekly cap of 50 pts",
  taskLikeOtherTitle: "Like Other Works",
  taskLikeOtherDesc: "Earn 0.5 pts per Like, daily cap of 5 pts ({n}/5 pts)",
  taskLikeMyTitle: "Receive Likes",
  taskLikeMyDesc: "Earn 1 pt per Like, weekly cap of 200 pts ({n}/200 pts)",
  taskFbTitle: "Follow on Facebook",
  taskFbDesc: "Follow the official Facebook (10 pts)",
  taskDcTitle: "Join on Discord",
  taskDcDesc: "Join the official Discord (10 pts)",
  taskYtbTitle: "Subscribe on Youtube",
  taskYtbDesc: "Subscribe to the official YouTube (10 pts)",
  taskLineTitle: "Follow on LINE",
  taskLineDesc: "Follow the official LINE (10 pts)",
  ugcTabContent6: "Black and white, pink, made with code...|What does the Poring in your heart look like?|Share your Poring creation|and let cuteness take over Midgard!|How to Participate:|Share your own Poring drawing or creation.|Any format is welcome,|including hand-drawn art, code, and more.",
  ugcTabContent7: "Share your skill build|and epic battle moments|so more adventurers can see your class highlights!|How to Participate:|Upload in-game screenshots|of combat or skill builds for any class.",
  ugcTabContent5: "The seamless open world|is the perfect photography studio.|Show off your unique outfits, check in at scenic spots,|and capture your own unforgettable moments in Midgard!|How to Participate:|Upload in-game screenshots|of outfit dyeing/styling and scenery.",
  communicationType1: "Feedback",
  communicationType2: "Dev Log",
  inputTitle: "Enter title",
  inputContent: "Enter content",
  uploadImage: "Edit Image",
  uploadImageTip: "Drag to reorder",
  addImage: "Add",
  creationBtnText: "Publish",
  publish: "Publish",
  loading: "Loading",
  publishSuccess: "Published, awaiting review",
  commonTip: "Please try again later",
  editSaveTip: "Save this edit?",
  saveCancel: "Discard",
  saveConfirm: "Save",
  myCreative: "My Creations",
  deleteTip: "Delete this creation?",
  confirmBtn: "Confirm",
  cancelBtn: "Cancel",
  submitBtn: "Submit",
  tipPopupTitle: "Notice",
  loginPopupTitle: "Notice",
  scoreDetailTitle: "My Points",
  lotterySuccTitle: "Congratulations",
  physicalAwardTitle: "Shipping Info",
  physicalCheckTitle: "Notice",
  vtCodeTitle: "Claimed",
  realNameLabel: "Full Name",
  phoneLabel: "Mobile",
  areaCodeLabel: "Country Code",
  addressLabel: "Shipping Address",
  countryLabel: "Country/Region",
  postalCodeLabel: "Postal Code",
  confirmShippingTip: "Shipping info cannot be changed after confirmation.<br />Are you sure?",
  submitSuccessTip: "Submitted successfully",
  scoreItemLabel: "Item",
  scoreChangeLabel: "Points",
  scoreTimeLabel: "Time",
  lotteryDrawLabel: "Points Draw",
  auditResultNotice: "Review Result",
  auditResultContent:
    "Dear player,<br/><br/>Your creation titled 【${title}】 submitted at ${time} did not pass review. Please revise and resubmit.",
  auditReason: "Reason: ",
  auditTime: "Review Time: ",
  emptyNotice: "No more content",
  emptyWorks: "Be the first to create!",
  viewImage: "Click to view original",
  createPopupTitle: "Publish Creation",
  gameName: "RO World Journey",
  gameType: "Open-World RO",
  loadingMore: "Scroll to load more",
  noMoreData: "No more content",
  auditPass: "Published",
  auditFail: "Rejected",
  auditState: "Under Review",
  ugcRuleRules: `Ragnarok: The New World UGC Submission Rules

I. Submission Requirements
1. All submissions must be related to Ragnarok: The New World and must be original works created by the submitter. Plagiarism, misappropriation, reposting, or unauthorized use of others' materials is strictly prohibited.
2. Submissions must comply with the corresponding category and event requirements.
3. If a submission includes third-party materials, music, images, or other copyrighted content, the submitter must ensure that they have obtained legal authorization. The submitter shall bear full responsibility for any disputes arising from copyright issues.
4. The official team reserves the right to review all submissions. For content that violates rules, is inappropriate, is of poor quality, is unrelated to the event, or fails to meet requirements, the official team reserves the right to refuse to display it, disqualify it from the event, and withhold any related points or rewards.

II. Work Display and Interaction
1. Approved entries will be displayed on the [Submission Wall] on the event page.
2. Players can browse, like, and interact with displayed entries.
3. The official team reserves the right to adjust the display order, recommended content, and display format of the entries based on event operational needs.

III. Authorization and Usage of Submissions
1. Upon successful submission, the submitter is deemed to have granted Ragnarok: The New World an official, global, perpetual, irrevocable, non-exclusive, and royalty-free license to use the submitted content.
2. The official team may use the submitted content within and outside the game, on the official website, social media platforms, marketing and promotional activities, merchandise production, and related derivative content.
3. To meet promotional and operational needs, the official team reserves the right to make any necessary edits, optimizations, adaptations, or remakes to the submitted content.
4. Submitters retain the copyright and attribution rights to their original works.

IV. Event Participation and Rewards
1. Players must complete all event-related actions within the specified timeframe, including but not limited to submitting entries, earning and redeeming points, claiming rewards, and providing shipping information.
2. If a player fails to complete relevant actions within the designated timeframe, they will be deemed to have automatically forfeited the corresponding eligibility, points, or rewards.
3. The official team will not reissue or restore any rewards that have not been claimed by the deadline, unused points, or incomplete information submissions.
4. The official team assumes no liability for any players' inability to participate or claim rewards resulting from players providing incorrect, incomplete, invalid, or outdated personal information.
5. The official team assumes no liability for any restrictions or bans on accounts, including those resulting from suspicious account activities, account theft, device issues, network problems, or violations of game rules, that affect event participation or claiming rewards. If an account is banned during the event period, any unused points or unclaimed rewards will automatically expire.

V. Anti-Cheating and Handling of Violations
The official team will closely monitor event participation. Should any of the following violations be detected, immediate action will be taken, including but not limited to suspending the involved accounts, revoking all eligibility for the event, recovering any rewards already distributed (including in-game items that have been used), and reserving the right to pursue legal action:
1. Using any method to create multiple accounts in bulk (such as accounts with the same username, device, and/or sharing the same IP address, etc.) to participate in the event.
2. Exploiting program vulnerabilities, using unofficial tools, or employing any illicit means to farm points.
3. Using illegal third-party software, cheats, or auxiliary tools to interfere with the event.
4. Any form of illicit or fraudulent interaction, such as self-liking, mutual-like spamming, or purchasing likes.
5. Providing false personal information or misappropriating another person's information.
6. Any other behavior determined by the official team to violate the fairness of the event or harm the gaming environment.

VI. Force Majeure Clause
In the event of force majeure factors beyond the official team's control (including but not limited to changes in government policies or regulations, natural disasters, epidemics, wars, etc.), the official team reserves the right to adjust the event schedule, including extending, shortening, or suspending the event as circumstances warrant, and will announce such changes on the official website or fan page at least 24 hours in advance. In the event of sudden force majeure (including but not limited to major server failures, hacker attacks, etc.) that prevents advance notice, the official team commits to issuing an announcement as soon as possible.

VII. Disclaimer
1. By participating in this event, players are deemed to have read, understood, and agreed to all rules and instructions for this event.
2. Minors or individuals with limited legal capacity must obtain consent from their legal guardian before participating in this event.
3. All activity-related records, including point acquisition, point usage, lucky draw results, and reward distribution, are subject to the official system records as the final authority.

※ The official team of Ragnarok: The New World reserves the right to the final interpretation of this event, and within the limits permitted by law, to adjust or supplement the event content, rules, and rewards based on actual circumstances. The official announcement shall prevail.`,
  rulePopupTitle: "Event Rules",
  overTenTips: "You've published 10 times today. Come back tomorrow!",
  rulePopupContent: ``,
  backText: "Back to UGC",
  21000: "Not logged in",
  21001: "Failed to get upload URL",
  21002: "Failed to merge file",
  21003: "Invalid slice count",
  21004: "Upload ID or path cannot be empty",
  21005: "Parameter error",
  21006: "Failed to submit content",
  21007: "Like failed",
  21008: "Failed to clear notification",
  21010: "Too many posts today, try again tomorrow",
  21011: "Too many submissions today, try again tomorrow",
  21013: "Too many submissions today, try again tomorrow",
  21014: "Invalid email format",
  21018: "Insufficient points",
  21019: "Draw failed",
  21022: "Event not ended",
  21023: "No physical reward to claim",
  21024: "Failed to claim physical reward",
  21025: "Content too long",
  21026: "You still have points available for drawing",
  21027: "No virtual reward to claim",
  21028: "Reward record not found",
  21029: "Reward does not belong to current user",
  21030: "Not a virtual reward",
  21031: "Reward not yet received",
  viewMyRewardsBtn: "View My Rewards",
  claimRewardsBtn: "Claim Rewards",
  claimVirtualBtn: "Claim Virtual Reward",
  claimPhysicalBtn: "Claim Physical Reward",
  myRewardsTitle: "My Rewards",
  prizeNameLabel: "Prize",
  prizeQtyLabel: "Quantity",
  obtainTimeLabel: "Obtained",
  currentStatusLabel: "Current Status",
  viewGiftCodeBtn: "View Gift Code",
  claimTips: "* Visit this page during the open beta to claim",
  congratulations: "Congratulations",
  giftCodeLabel: "Gift Code:",
  copyBtn: "Copy",
  copiedBtn: "Copied",
  useGiftCodeTips: "Redeem claimed gift code in the game!",
  unclaimedStatus: "Unclaimed",
  claimedStatus: "Claimed",
  oneDraw: "1 Draw",
  tenDraw: "10 Draws",
  lotteryPointCost: "Each draw costs: 25 pts",
  spendPointsFirst: "Spend points first, then claim your rewards after drawing!",
  claimVirtualRewardSuccess: "Please check [My Prizes] for gift codes",
  submitting: "Submitting...",
  submitSuccess: "Submitted successfully!",
  submitFailed: "Submission failed, please retry",
  imageRequired: "Please upload an image",
  footerProvision: `
    <ol>
        <li>This game contains violence, romance, and suggestive costumes</li>
        <li>Some content requires additional payment</li>
        <li>Please avoid excessive gaming</li>
    </ol>
  `,
  taskRulePopupTitle: "Rules",
  taskRuleRules: `《Ragnarok: The New World》Point Draw Event Rules

I. Event Period
July 17, 2026 00:00 – August 24, 2026 23:59 (UTC+7)

II. How to Earn Points
1. First daily login: 5 pts/day, limited to 1 time per day.
2. Pre-registration: 25 pts, counted only once for the first registration.
3. Follow official social accounts (Facebook, Discord, LINE, YouTube): 10 pts per platform, limited to 1 time per platform.
4. Submit feedback: 15 pts, only the first submission each day counts.
5. Submit to "My Poring" event: image required, 25 pts, only the first submission each day counts, max 2 submissions per week.
6. Submit to "Class Sharing" event: image required, 25 pts, only the first submission each day counts, max 1 submission per week.
7. Submit to "Photo Sharing" event: image required, 25 pts, only the first submission each day counts, max 2 submissions per week.
8. Like others' works: 0.5 pts/like, only the first like on each work counts; un-liking and re-liking does not earn additional points. Only the first 10 valid likes per day earn points.
9. Receive likes on your works: 1 pt/like. To prevent abuse, a single account can earn a maximum of 200 pts per week through this method.
10. Liking accounts must be active and valid. The official system monitors abnormal liking patterns. The official team reserves the right to void points earned through cheating (including but not limited to self-liking and mutual-liking groups).
11. Daily participation counts reset at 00:00 each day; weekly participation counts reset at 00:00 every Monday.

III. Point Draw Rules
1. Players earn points by participating in co-creation events during the event period. Every 25 points can be exchanged for one draw; every 250 points can be used for a 10-draw. Points are only valid during the draw event period and will expire after the event ends.
2. Rewards and probabilities:
- No prize (20%)
- Game item: Exclusive Headwear [Black Cat Ears] ×1 (2%)
- Game item: Exclusive Avatar Frame [Co-Creation Planner] ×1 (3%)
- Game item: Exclusive Title [Threw a Dead Branch at the Planner] ×1 (6%)
- Game item: Kafra Mystery Box ×1 (10%)
- Game item: Bound Zeny ×3,000 (12%)
- Game item: Adventure Coins ×10,000 (30%)
- Physical merchandise: BABYMONSTER Collab Limited Photocards (Full Set) ×1 (1%)
- Physical merchandise: Limited Plushie ×1 (3%)
- Physical merchandise: Collectible Card ×1 (4%)
- Physical merchandise: Collab Backpack ×1 (4%)
- Physical merchandise: Adventure Picnic Mat ×1 (5%)

IV. Prize Claim Rules
1. The prize claim function will be available after the event ends.
2. Virtual prize claim rules:
   1) Virtual prizes won during the event can be viewed by clicking "View My Prizes."
   2) After the event ends, players may claim the corresponding gift codes on this page and redeem them in-game.
3. Physical prize claim rules:
   1) Winners must provide complete and accurate shipping information on the event page within 30 business days after the event ends. Failure to provide information or late submissions will be treated as forfeiture of the prize.
   2) Required shipping information: ① Full name ② Valid phone number ③ Full address including street number ④ Postal code.
   *Please carefully verify all information. The official team is not responsible for failed delivery, lost, or returned prizes due to incorrect, incomplete, or uncontactable recipient information. Personal information provided will only be used for prize delivery and related administrative purposes; the organizer will handle it confidentially in accordance with relevant laws.
   3) Physical prize delivery: Expected to be shipped within 30–60 business days after the event ends. Please be patient.
   4) Please note: this event is only open to players in Thailand, Cambodia, Timor-Leste, Indonesia, Laos, Malaysia, Myanmar, Philippines, and Singapore. Shipping addresses outside these regions will be treated as prize forfeiture.

V. Player Responsibilities & Forfeiture
1. Players are responsible for monitoring event rules and all deadlines (event period, point earn/redeem period, address submission deadline, virtual prize claim period, etc.). Failure to participate, redeem draws, submit a shipping address, or claim virtual prizes within the official deadlines will be treated as automatic forfeiture of the relevant rights.
2. All losses resulting from forfeiture (including but not limited to point expiration and unclaimed prizes) are the player's own responsibility. The official team is not obligated to provide any form of compensation or restoration.

VI. Content Copyright & Usage
By submitting, you grant the game official a worldwide, perpetual, irrevocable, royalty-free license for use inside and outside the game, including marketing, promotion, adaptation, and derivative works. The official team has the right to modify, optimize, produce, and reproduce your submission and use it in-game, for game merchandise, market promotions, and related activities.

VII. Anti-Cheating & Violation Handling
The official team strictly monitors event participation. Upon detection of the following violations, the official team reserves the right to immediately take actions including but not limited to blocking the involved account(s), revoking all event eligibility, reclaiming distributed rewards (including used virtual items), and pursuing legal liability:
1. Mass creation of alt accounts (same person, same device, same IP multi-account) to participate in the event.
2. Using exploits, unofficial tools, or any abnormal means to farm points.
3. Using illegal third-party software, cheats, or auxiliary tools to interfere with the event.
4. Any form of self-liking, mutual like farming, purchasing likes, or other abnormal/fake interaction behaviors.
5. Providing false personal information or misusing another person's information.
6. Any other behavior deemed by the official team to violate event fairness or harm the game environment.

VIII. Force Majeure
In the event of force majeure circumstances beyond the official team's control (including but not limited to: government policy changes, natural disasters, epidemics, wars), the official team reserves the right to adjust the event timeline — extending, shortening, or suspending the event — with at least 24 hours' prior notice on the official website or fan page. In the event of sudden force majeure (including but not limited to: major server failures, hacker attacks) where advance notice is not possible, the official team commits to announcing as soon as possible.

IX. Disclaimer
By participating in this event, you confirm that you have fully read, understood, and agreed to the following:
1. If you are a minor or a person with limited legal capacity, you have obtained the consent of your legal guardian before participating.
2. Time-lapse forfeiture: failure to complete required actions within the official specified timeframes (point redeem period, address submission deadline, virtual prize claim period, etc.) will be treated as automatic forfeiture of the relevant rights.
3. Information error responsibility: the official team is not responsible for any inability to earn points, participate in draws, receive prizes, or any other losses caused by incorrect, false, expired, or not-timely-updated personal information (including but not limited to shipping information and account information) provided by the player.
4. Account security & status responsibility: the official team is not responsible for any inability to participate in the event, point losses, unclaimed prizes, or any other losses caused by account hacking, personal device issues, network issues, or account suspension due to violation of game rules. If an account is suspended during the event, any unused points and undistributed rewards will be automatically voided.
5. System records are authoritative: all point earning, spending, draw records, and win records are subject to the final data in the official system backend.

※ 《Ragnarok: The New World》 reserves the right to the final interpretation of this event and may, within the scope permitted by law, adjust or supplement the event content, rules, and rewards based on actual circumstances. Official announcements shall prevail.`,
  rulePopupContent: ``,
  createPopupTip: "By submitting, you grant the game official a worldwide, perpetual, irrevocable, royalty-free license for use inside and outside the game including marketing, promotion, adaptation and derivative works.",
  checkTermsTip: 'Please agree to the authorization terms',
  imageUploadingTip: 'Image is uploading, please wait',
  imageSizeTip: 'Image size cannot exceed 10MB',
  imageFormatTip: 'Only JPG and PNG formats are supported',
  imageMaxTip: 'You can upload up to 3 images',
  imageUploadFailTip: 'Image upload failed, please try again',
  saveConfirmMessage: 'Do you want to keep the current edits?',
  footerRatingLines: ['This game contains violence and romance content', 'Some content requires additional payment', 'Please avoid excessive gaming'],
  footerTermsText: 'Terms of Service',
  footerPrivacyText: 'Privacy Policy',
  awardThanks: 'Thank You',
  awardTitle: 'Custom Title [Extending the Dead Branch]*1',
  awardAvatar: 'Custom Avatar Frame [Co-creator]*1',
  awardHeadwear: 'Custom Headwear [Black Cat Ears]*1',
  awardBlindbox: 'Kafra Blind Box*1',
  awardZeny: 'Bound Zeny*3000',
  awardCoin: 'Adventure Coin*10000',
  awardDoll: 'Limited Plush',
  awardCard: 'Collectible Card',
  awardTshirt: 'ROW T-Shirt',
  awardBackpack: 'Collab Backpack',
  awardPhotocard: 'BABYMONSTER Collab Limited Photocard Set',
  awardPhoneHolder: 'Baphomet Phone Holder',
  awardCanvasBag: 'New World Canvas Bag',
  awardFridgeMagnet: 'Novice Fridge Magnet',
  awardWaistPillow: 'RO Job Book Lumbar Pillow',
  scoreTitleNone: 'None',
  scoreTitleLv1: 'Big Brain Novice',
  scoreTitleLv2: 'All-in on RO',
  scoreTitleLv3: 'Demiurge',
  footerTermsUrl: 'https://www.gnjoy.hk/Terms',
  footerPrivacyUrl: 'https://www.gnjoy.hk/Policies',
};
